/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
// import { Link } from 'gatsby';
import Image from '@ecs/tng-common/components/image/Image';
import LazyLoadedComponent from '@ecs/tng-common/components/lazy-loaded-component/LazyLoadedComponent';
import { NumberFormatValues, NumericFormat } from 'react-number-format';
import { sharedAssetsPath } from '@ecs/tng-common/scripts/data';
import { themes } from '../helpers/interfaces';
import { pathPrefix } from '../helpers/routes';
import { Link } from 'gatsby';

type CreditScoreSearchProps = {
  variant: themes;
  className?: string;
};
type CreditScoreSearchState = {
  error: string;
};
// eslint-disable-next-line react/prefer-stateless-function
export default class CreditScoreSearch extends React.Component<
  CreditScoreSearchProps,
  CreditScoreSearchState
> {
  constructor(props: CreditScoreSearchProps) {
    super(props);
    this.state = {
      error: ''
    };
  }

  render() {
    const { variant } = this.props;
    const examples = [600, 700, 780, 803];
    const getUrl = (score: number) => {
      return `${pathPrefix}/credit-education/score-basics/${score}-credit-score/`;
    };
    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();

      // If the value is valid, proceed with form submission
      const form = event.currentTarget;
      const creditScoreInput = form.querySelector<HTMLInputElement>('#credit-score');
      const creditScore = parseFloat(creditScoreInput?.value || '0') || null;
      if (creditScore && creditScore >= 300 && creditScore <= 850) {
        window.location.href = getUrl(creditScore);
      } else {
        this.setState({ error: 'Credit score ranges between 300 and 850' });
      }
    };
    const isAllowed = (values: NumberFormatValues) => {
      const { formattedValue, floatValue } = values;
      // Allow empty value
      if (formattedValue === '') {
        return true;
      }
      // Restrict to a maximum of 3 digits
      if (formattedValue.length > 3) {
        return false;
      }
      // Do not allow numbers that start with 0, 1, 2, or 9
      if (/^[1290]/.test(formattedValue) || (floatValue && floatValue > 850)) {
        return false;
      }
      return true;
    };
    return (
      <LazyLoadedComponent
        lazyLoading
        as="div"
        id="credit-score-search"
        className={`${variant === 'dark' ? 'bg-purple text-white' : 'bg-coconut border'} p-3 p-lg-4 rounded position-relative ${this.props.className || ''}`}>
        <h2 className="h5 mb-5 flex-fill pe-9 pe-sm-0">How good is your credit score?</h2>
        <Image
          src={`${sharedAssetsPath}/icons/icon-monitor.svg`}
          alt="Monitor credit score icon."
          width="120"
          height="120"
          className="spot-icon-lg position-absolute"
          lazyLoading
        />
        <form
          onSubmit={handleSubmit}
          className="mb-2 col-12 col-sm-10 col-md-9 col-lg-8 pe-3">
          <label
            htmlFor="credit-score"
            className="fw-bold mb-3">
            Enter your credit score
          </label>
          <div
            className={`${this.state.error ? 'error-input' : ''} input-group ${variant === 'dark' ? 'border-0' : 'border'} rounded-2`}>
            <NumericFormat
              id="credit-score"
              name="credit-score"
              type="tel"
              maxLength={3}
              allowNegative={false}
              required
              isAllowed={isAllowed}
              allowLeadingZeros={false}
              onChange={() => {
                this.setState({ error: '' });
              }}
              className="form-control border-0"
              placeholder="Enter your credit score"
            />
            {this.state.error && <p className="text-error">{this.state.error}</p>}
            <button
              className="btn bg-white ecs-font-icon-act-search text-gray h5 mb-0"
              type="submit"
              aria-label="Enter your credit score"
            />
          </div>
        </form>
        <p className="body-text-xs mb-0 ps-3">
          Examples:&nbsp;
          {examples.map((score: number, index: number) => {
            return (
              <span key={score}>
                <Link
                  className={`${variant === 'dark' ? 'text-white' : ''}`}
                  to={getUrl(score)}>
                  {score}
                </Link>
                {index < examples.length - 1 ? ', ' : ''}
              </span>
            );
          })}
        </p>
      </LazyLoadedComponent>
    );
  }
}
